import { useState } from 'react';

interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 sm:py-4 flex items-center justify-between">
        <div className="flex items-center gap-2 sm:gap-3">
          <img 
            alt="ぽかぽか堂 よりみち相談室" 
            className="h-11 sm:h-16 lg:h-18 w-auto" 
            src="https://static.readdy.ai/image/e68483200b29d1db925b252765737b7b/d42e6993fa69380b98ac51f79be2a451.png"
          />
        </div>
        <div className="hidden lg:flex items-center gap-8 xl:gap-12">
          <button 
            onClick={() => scrollToSection('services')}
            className="text-[#2C2C2C] hover:text-[#66BB6A] transition-colors cursor-pointer font-medium text-sm xl:text-base"
          >
            サービス内容
          </button>
          <button 
            onClick={() => scrollToSection('plans')}
            className="text-[#2C2C2C] hover:text-[#66BB6A] transition-colors cursor-pointer font-medium text-sm xl:text-base"
          >
            料金プラン
          </button>
          <button 
            onClick={() => scrollToSection('contact')}
            className="text-[#2C2C2C] hover:text-[#66BB6A] transition-colors cursor-pointer font-medium text-sm xl:text-base"
          >
            ご予約
          </button>
          <button 
            onClick={() => scrollToSection('contact')}
            className="text-[#2C2C2C] hover:text-[#66BB6A] transition-colors cursor-pointer font-medium text-sm xl:text-base"
          >
            お問合せ
          </button>
        </div>
        <button 
          onClick={() => scrollToSection('contact')}
          className="hidden lg:block bg-[#81C784] text-white px-6 xl:px-8 py-2 xl:py-3 rounded-full hover:bg-[#66BB6A] transition-all whitespace-nowrap cursor-pointer font-medium text-sm xl:text-base"
        >
          無料相談を予約する
        </button>
        <button 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="lg:hidden text-[#2C2C2C] cursor-pointer"
        >
          <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* モバイルメニュー */}
      <div className={`lg:hidden transition-all duration-300 overflow-hidden ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="bg-white/95 backdrop-blur-sm shadow-lg">
          <div className="max-w-7xl mx-auto px-4 py-4 space-y-3">
            <button 
              onClick={() => scrollToSection('services')}
              className="w-full text-left text-[#2C2C2C] hover:text-[#66BB6A] hover:bg-[#E8F5E9] transition-colors cursor-pointer font-medium py-3 px-4 rounded-lg"
            >
              サービス内容
            </button>
            <button 
              onClick={() => scrollToSection('plans')}
              className="w-full text-left text-[#2C2C2C] hover:text-[#66BB6A] hover:bg-[#E8F5E9] transition-colors cursor-pointer font-medium py-3 px-4 rounded-lg"
            >
              料金プラン
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="w-full text-left text-[#2C2C2C] hover:text-[#66BB6A] hover:bg-[#E8F5E9] transition-colors cursor-pointer font-medium py-3 px-4 rounded-lg"
            >
              ご予約
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="w-full text-left text-[#2C2C2C] hover:text-[#66BB6A] hover:bg-[#E8F5E9] transition-colors cursor-pointer font-medium py-3 px-4 rounded-lg"
            >
              お問合せ
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="w-full bg-[#81C784] text-white py-3 px-4 rounded-full hover:bg-[#66BB6A] transition-all whitespace-nowrap cursor-pointer font-medium text-center"
            >
              無料相談を予約する
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
